<div class="card-body-div notification-settings">
  <form>
    <div *ngIf="isLoading" class="panel">
      <app-loader></app-loader>
    </div>
    <div class="row">
      <div class="col">
        <accordion [isAnimated]="true" [closeOthers]="false" class="notification-settings__accordion">
          <ng-container *ngFor="let profile of profiles$|async; let index = index; let even = even;">
            <accordion-group id="{{'group'+index}}" heading={{profile.displayName}}
                             [panelClass]="'notifications-panel translated-newline' + ' ' + (!even ? 'notifications-panel_white' : 'notifications-panel_grey')"
                             [isOpen]="true">
              <app-profile-notifications [profile]="profile" [notificationSettings]="notificationSettings"
                                         [isEthDisabled]="isEthDisabled" [index]="index"
                                         (updateSettings)="updatePofileNotificationSetting($event)"></app-profile-notifications>
            </accordion-group>
          </ng-container>
        </accordion>
      </div>
    </div>
  </form>
</div>
